import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"ecommerce App Development",
      slug:""
    },
  ]
}

export default function EcomBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner ecom-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/ecom-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <label>AI-Powered</label>
          <h1 className="heading center-heading"><span>Advanced E-Commerce App </span> 
          Development for Enterprises</h1>
          <p className="sub-heading">Empowering businesses with advanced, scalable, and user-friendly e-commerce solutions to enhance performance, streamline operations, and drive growth in today’s digital era.</p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">
          get started
          </Link> 
        </div>
      </section>
    </>
  )
}
